import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

const LedgerIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <g
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="4" y="3" width="16" height="18" rx="2" />
      <path d="M8 3v18M11 8h5M11 12h5M11 16h3" />
    </g>
  </SvgIcon>
)

export default LedgerIcon
